/**
 * The connection security the Connected Emails forms offer for a server-and-password account.
 *
 * Campus connects a new account, one held to certificate checks, and one moved to another server or port only over
 * SSL or STARTTLS (shown as TLS). An older account that stays on the server and port it was saved with may stay
 * unencrypted.
 */
export interface SmtpSecurityOption {
    value: string;
    label: string;
}

export const DEFAULT_SMTP_SECURITY = 'TLS';

/** The STARTTLS submission port */
export const DEFAULT_SMTP_PORT = '587';

const normaliseHost = (host: string): string => host.trim().toLowerCase().replace(/\.+$/, '');

export const smtpSecurityOptions = (allowUnencrypted: boolean): SmtpSecurityOption[] => [
    ...(allowUnencrypted ? [{ value: 'None', label: 'None' }] : []),
    { value: 'SSL', label: 'SSL' },
    { value: 'TLS', label: 'TLS' },
];

/**
 * Whether an edited account may stay unencrypted: only one not held to certificate checks, still on the server and
 * port it was saved with. Server names are compared as Campus compares them, ignoring case, spacing and a trailing
 * dot.
 */
export const mayStayUnencrypted = (
    verifyCertificate: boolean,
    storedHost: string,
    storedPort: number | string,
    host: string,
    port: number | string,
): boolean =>
    !verifyCertificate && normaliseHost(storedHost) === normaliseHost(host) && Number(storedPort) === Number(port);
